module.exports = __webpack_public_path__ + "img/snead-logo.09549f80.jpg";